import axios from 'axios';
import { FC, useEffect, useLayoutEffect, useState } from 'react';
import { Setting, statusMessages, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';
import style from '../styles/SubscriptionList.module.css';
import SubscriptionItem from './SubscriptionItem';

export type StatusMessage = keyof typeof statusMessages;

export const SubscriptionList: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

  useEffect(() => {
    window.parent.postMessage({ action: 'subscriptionList' }, '*');

    axios
      .post(`${CUSTOMER_API_URL}?action=getSubscriptions`, {}, { headers: { Authorization: setting.token } })
      .then((response) => {
        setSubscriptions(response.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight + 15; // buffer;

    setting.resize(height);
    window.parent.postMessage({ action: 'subscriptionList' }, '*');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptions]);

  const topic =
    subscriptions && subscriptions.length > 0 && subscriptions[0].shop!.mypageRemarks ? (
      <div className="huckleberry-subscription-list-memo">
        <p dangerouslySetInnerHTML={{ __html: subscriptions[0].shop!.mypageRemarks }} />
      </div>
    ) : (
      <></>
    );

  const rank =
    subscriptions && subscriptions.length > 0 && subscriptions[0].shop.rankGroup?.public && subscriptions[0].rank?.name ? (
      <div className="huckleberry-subscription-list-rank">
        <span className="item rank">{subscriptions[0].rank.name}</span>
        <span className="item rank-benefits">{subscriptions[0].rank.discountPercentage}%割引</span>
      </div>
    ) : (
      <></>
    );

  console.log('subscriptions', subscriptions);

  const activeSubscriptions = subscriptions.filter((subscription) => subscription.status !== 'CANCELLED');

  console.log('subscriptionLength', activeSubscriptions.length);

  return (
    <>
      <div className={style.subscriptionList}>
        {/* <header>
        <h2 className={style.subscriptionListHeading}>定期購入一覧</h2>
        {topic}
        {rank}
      </header> */}
        <div className={style.subscriptionListBody}>
          {activeSubscriptions.length > 0 ? (
            activeSubscriptions.map((subscription, index) => (
              <SubscriptionItem
                key={`${subscription.subscriptionContractId}_${index}`}
                subscriptionContractId={subscription.subscriptionContractId}
                setting={setting}
                last={activeSubscriptions.length === index + 1}
              />
            ))
          ) : (
            <div className={style.subscriptionListEmpty}>
              <p>現在ご利用の定期便はありません。</p>
            </div>
          )}

          {/* <div className={base.sectionBtnGroup}>
          <a href={`${setting.referrer}/account`} target="_parent" className={base.sectionBtn}>
            <span>戻る</span>
          </a>
        </div> */}
        </div>
      </div>
    </>
  );
};
